import { AdvisorLayerMode } from '../enums/advisorLayerMode'

const EXPERT_PATH_SEGMENT = 'expert'

export const getModeFromPath = (pathname: string): AdvisorLayerMode | undefined => {
  const [, , layerSegment] = pathname.split('/')

  if (!layerSegment) {
    return undefined
  }

  if (layerSegment === EXPERT_PATH_SEGMENT) {
    return AdvisorLayerMode.Expert
  }

  return AdvisorLayerMode.Client
}
